import { Rollout } from '../../../lib/PlannerDTOs';
import { State } from '../../../store/state';
import { rolloutEntitiesSelector } from '../../../store/state/entities/selectors';

export const rolloutSelector = (
  state: State,
  rolloutKey: string,
): Rollout | null => {
  const rolloutEntities = rolloutEntitiesSelector(state);
  const rollout = rolloutEntities ? rolloutEntities[rolloutKey] : null;
  return rollout;
};

export const rolloutVersionSelector = (
  state: State,
  variableName: string,
  version: string,
): Rollout | null => {
  const key = `${variableName}--${version}`;
  const rollout = rolloutSelector(state, key);
  return rollout;
};

export const latestRolloutSelector = (
  state: State,
  variableName: string,
): Rollout | null => {
  const latestRollouts = state.rollouts!.latestRollouts;
  const latestVersion = latestRollouts[variableName];
  const latestRollout = latestVersion
    ? rolloutVersionSelector(state, variableName, latestVersion)
    : null;
  return latestRollout;
};

export const rolloutViewSelector = (state: State) => {
  return state.rollouts!.view;
};
